import PropTypes from "prop-types";

import AdminConsoleStepFormModal from "@/admin/AdminConsoleStepFormModal";
import useFacultyAdderReducer, {
  FACULTY_ADDER_ACTIONS,
} from "@/admin/hooks/useFacultyAdderReducer";
import HideWhenUnlockOrPreviewContentBannerIsShown from "@/components/UnlockOrPreviewContentBanner";
import AddIcon from "@/icons/AddIcon";
import ChevronLeftIcon from "@/icons/ChevronLeftIcon";
import AdminConsoleFacultyAdderModalContent from "./AdminConsoleFacultyAdderModalContent";
import { getButtonStatus } from "./AdminConsoleFacultyAdderModal.utils";
import {
  contentHeaderCss,
  addIconCss,
  chevronLeftIconCss,
} from "./AdminConsoleFacultyAdderModal.style";

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

const FACULTY_ADDER_PROPS = {
  id: "faculty_adder",
  title: "Add faculty",
  triggerButtonLabel: "Add faculty",
  triggerButtonIcon: {
    iconNode: <AddIcon css={addIconCss} />,
    isIconBeforeText: true,
  },
  nextButtonLabel: "Next",
  submitButtonLabel: "Add faculty",
  cancelButtonLabel: "Cancel",
  backButtonLabel: "Back",
  backButtonIcon: {
    iconNode: <ChevronLeftIcon css={chevronLeftIconCss} />,
    isIconBeforeText: true,
  },
  formHeadingId: "form_faculty_content_heading",
  totalSteps: 2,
};

const getButtonLabels = (step) => {
  if (step === 1) {
    return [
      FACULTY_ADDER_PROPS.cancelButtonLabel,
      FACULTY_ADDER_PROPS.nextButtonLabel,
    ];
  }

  return [
    FACULTY_ADDER_PROPS.backButtonLabel,
    FACULTY_ADDER_PROPS.submitButtonLabel,
    FACULTY_ADDER_PROPS.backButtonIcon,
  ];
};

const AdminConsoleFacultyAdderModal = ({ onSubmit }) => {
  const [facultyAdderState, dispatch] = useFacultyAdderReducer();

  const handleCancelButton = () => {
    dispatch({ type: FACULTY_ADDER_ACTIONS.RESET_STATE });
  };
  const handleSubmitButton = () => {
    onSubmit(facultyAdderState);
    dispatch({ type: FACULTY_ADDER_ACTIONS.RESET_STATE });
  };

  const isNextSubmitButtonActive = getButtonStatus(facultyAdderState);

  const [cancelBackButtonLabel, nextSubmitButtonLabel, cancelBackButtonIcon] =
    getButtonLabels(facultyAdderState.step);

  return (
    <HideWhenUnlockOrPreviewContentBannerIsShown>
      <AdminConsoleStepFormModal
        id={FACULTY_ADDER_PROPS.id}
        title={FACULTY_ADDER_PROPS.title}
        triggerLabel={FACULTY_ADDER_PROPS.triggerButtonLabel}
        triggerIcon={FACULTY_ADDER_PROPS.triggerButtonIcon}
        totalSteps={FACULTY_ADDER_PROPS.totalSteps}
        currentStep={facultyAdderState.step}
        cancelBackButtonLabel={cancelBackButtonLabel}
        cancelBackButtonIcon={cancelBackButtonIcon}
        nextSubmitButtonLabel={nextSubmitButtonLabel}
        ariaLabelledById={FACULTY_ADDER_PROPS.formHeadingId}
        onCancel={handleCancelButton}
        onSubmit={handleSubmitButton}
        dispatchAction={dispatch}
        isNextSubmitButtonActive={isNextSubmitButtonActive}
      >
        <>
          <h2 css={contentHeaderCss} id={FACULTY_ADDER_PROPS.formHeadingId}>
            Complete the user's new profile.
          </h2>
          <AdminConsoleFacultyAdderModalContent
            facultyAdderState={facultyAdderState}
            dispatchAction={dispatch}
          />
        </>
      </AdminConsoleStepFormModal>
    </HideWhenUnlockOrPreviewContentBannerIsShown>
  );
};

AdminConsoleFacultyAdderModal.propTypes = propTypes;

export default AdminConsoleFacultyAdderModal;

export { FACULTY_ADDER_PROPS };
